<template>
    <ul class="paymethod-list-dom" v-loading="loading">
        <paymentMethod v-for="(v, i) in paymentList" :key="i + new Date().getTime()" :obj="v" @clickDelete="clickDelete" @clickEdit="clickEdit" />
    </ul>
</template>

<script setup>
    import paymentMethod from "@/components/shopopee/material/paymentMethod"
    import {toRef, ref, onMounted, inject} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import eshopopeeApi from "@/request/eshopopeeApi";
    import myUtil from "@/util/util";

    const userInfoRef = toRef(useUserinfo())

    const emits = defineEmits(['clickEdit', 'clickDelete'])

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    const paymentList = ref([])

    const loading = ref(false)

    function getPaymentList() {
        loading.value = true
        const request = eshopopeeApi.getPaymentList
        const params = request.getParams()

        params.CompanyCode = shopCompany.value.acccompanycode

        request.send(params, getListCallback)
    }

    function getListCallback(res) {
        loading.value = false
        if (myUtil.isNotEmpty(res)){
            paymentList.value = res
        }else{
            paymentList.value = []
        }
    }

    function clickEdit(obj) {
        emits("clickEdit", obj)
    }

    function clickDelete(obj) {
        const id = obj.id

        const request = eshopopeeApi.delPayment
        const params = request.getParams()
        params.CompanyCode = shopCompany.value.acccompanycode
        params.paymentID = id

        request.send(params, (res) => {
            for (let i=0; i<paymentList.value.length; i++){
                const v = paymentList.value[i]

                if (v.id == id){
                    paymentList.value.splice(i, 1)
                    break
                }
            }
        })

        myUtil.alertSuccess("刪除成功")
    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()
        getPaymentList()
    })

</script>

<style scoped>
    .paymethod-list-dom {
        margin: 0;
        list-style: none;
        min-height: 300px;
        padding-top: 20px;
        padding-left: 0;
    }
</style>